import ErrorAlert from 'components/Alert/ErrorAlert';
import { SnackbarMessage } from 'notistack';
import { forwardRef } from 'react';

interface ErrorSnackbarProps {
  message: SnackbarMessage;
}

const ErrorSnackbar = forwardRef<HTMLDivElement, ErrorSnackbarProps>(({ message }, ref) => (
  <div ref={ref}>
    <ErrorAlert>{message}</ErrorAlert>
  </div>
));

export default ErrorSnackbar;
